module.exports = __webpack_public_path__ + "img/pork-stamp.62021c3c.png";